import React from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

import MovieFull from './movie-full';
import { avangaEncodeURI } from './../helpers';

// 3rd Party
import Masonry from 'react-masonry-component';
import Slider from 'react-slick';

class Movies extends React.Component {
  constructor(props) {
    super(props);

    const isMobile = window.innerWidth <= 640;

    let currentMovies = [];

    props.content.movies.map(movieItem => {
      if (movieItem.category.includes('new')) {
        currentMovies = [...currentMovies, movieItem];
      }
    });

    this.filterMoviesTitleURL = this.filterMoviesTitleURL.bind(this);
    this.resizeHandler = this.resizeHandler.bind(this);
    this.mouseOverHandler = this.mouseOverHandler.bind(this);
    this.filterHandler = this.filterHandler.bind(this);

    this.state = {
      currentCategory: 'new',
      currentMovies,
      isMobile,
      masonryOptions: { gutter: 12 },
      movies: props.content.movies,
      sliderSettings: {
        adaptiveHeight: false,
        arrows: true,
        dots: false,
        infinite: true,
        nextArrow: React.createElement('div', null, 'next'),
        prevArrow: React.createElement('div', null, 'prev'),
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToScroll: 3,
              slidesToShow: 3
            }
          },
          {
            breakpoint: 100000,
            settings: {
              slidesToScroll: 1,
              slidesToShow: 6
            }
          }
        ],
        speed: 500
      }
    };
  }

  resizeHandler() {
    const isMobile = window.innerWidth <= 640;

    if (this.state.isMobile !== isMobile) {
      this.setState({ isMobile });
    }
  }

  filterHandler(category) {
    const activeItems = document.querySelectorAll(`.movie-filter ul li.${category}`),
      filterItems = document.querySelectorAll('.movie-filter ul li');
    let currentMovies = [];

    this.props.content.movies.map(movieItem => {
      if (movieItem.category.includes(category)) {
        currentMovies = [...currentMovies, movieItem];
      }
    });

    // Remove active class from filter items.
    for (const item of filterItems) {
      item.classList.remove('active');
    }

    // Add active class to clicked filter.
    for (const item of activeItems) {
      item.classList.add('active');
    }

    this.setState({ currentMovies });
  }

  mouseOverHandler(event) {
    const animatedImg = event.target.querySelector('img.animated');

    // Set the src new, the gif will animate again
    animatedImg.src = animatedImg.src;
  }

  render() {
    return (
      <section className="movies">
        <Router>
          <div>
            <div className="movie-filter">
              <ul>
                <Slider {...this.state.sliderSettings}>
                <li className="new active" onClick={() => this.filterHandler('new')}>
                  <Link to="/">
                  <img width="70" height="70" className="img-circle animated" alt="New" src={`${require('../../../public/img/movie-icons/01_icon_project_new.gif')}`} />
                  <h3 className="filter-heading">New</h3></Link>
                </li>
                <li className="image" onClick={() => this.filterHandler('image')}>
                  <Link to="/">
                  <img width="70" height="70" className="img-circle animated" alt="New" src={`${require('../../../public/img/movie-icons/02_icon_project_corporate.gif')}`} />
                  <h3 className="filter-heading">Image</h3></Link>
                </li>
                <li className="recruiting" onClick={() => this.filterHandler('recruiting')}>
                  <Link to="/">
                    <img width="70" height="70" className="img-circle animated" alt="RECRUITING" src={`${require('../../../public/img/movie-icons/icon_recruiting.gif')}`} />
                    <h3 className="filter-heading">RECRUITING</h3></Link>
                </li>
                <li className="cgi" onClick={() => this.filterHandler('cgi')}>
                  <Link to="/">
                  <img width="70" height="70" className="img-circle animated" alt="CGI" src={`${require('../../../public/img/movie-icons/04_icon_project_animation.gif')}`} />
                  <h3 className="filter-heading">CGI</h3></Link>
                </li>
                <li className="multimedia" onClick={() => this.filterHandler('multimedia')}>
                  <Link to="/">
                    <img width="70" height="70" className="img-circle animated" alt="MULTIMEDIA" src={`${require('../../../public/img/movie-icons/icon_multimedia.gif')}`} />
                    <h3 className="filter-heading">MULTIMEDIA</h3></Link>
                </li>
                <li className="spot" onClick={() => this.filterHandler('spot')}>
                  <Link to="/">
                  <img width="70" height="70" className="img-circle animated" alt="New" src={`${require('../../../public/img/movie-icons/06_icon_project_commercial.gif')}`} />
                  <h3 className="filter-heading">Spot</h3></Link>
                </li>
                <li className="web" onClick={() => this.filterHandler('web')}>
                  <Link to="/">
                    <img width="70" height="70" className="img-circle animated" alt="New" src={`${require('../../../public/img/movie-icons/03_icon_project_web.gif')}`} />
                    <h3 className="filter-heading">Web</h3></Link>
                </li>
                <li className="tv" onClick={() => this.filterHandler('tv')}>
                  <Link to="/">
                    <img width="70" height="70" className="img-circle animated" alt="New" src={`${require('../../../public/img/movie-icons/05_icon_project_tv.gif')}`} />
                    <h3 className="filter-heading">Tv</h3></Link>
                </li>
                </Slider>

              </ul>
            </div>

            <div className="movies">
              <Masonry options={this.state.masonryOptions}>
                {this.state.currentMovies.map((movieItem, index) => [
                  <article key={movieItem.title} className="movie-teaser">
                    <Link to={`/video/${avangaEncodeURI(movieItem.title)}`}>
                      <div className="movie-teaser-wrap">
                        {movieItem.award &&
                          <div className="award">Award</div>
                        }

                        <img src={`${require(`../../../public/content/assets/${movieItem.teaser_image}`)}`} />

                        <div className="hover-wrap">
                          <div className="position-wrap">
                            <h3>{movieItem.title_teaser}</h3>
                            <div className="subline">{movieItem.subline_teaser}</div>

                            <Link to={`/video/${avangaEncodeURI(movieItem.title)}`} className="read-more"></Link>

                          </div>
                        </div>
                      </div>
                    </Link>
                  </article>,
                  <Route path={'/'} children={({ match }) => (
                    <MovieFull isMobile={this.state.isMobile} index={index} match={match} items={this.state.currentMovies} />
                  )} />
                ])}
              </Masonry>
            </div>
          </div>

        </Router>
      </section>
    );
  }

  filterMoviesTitleURL(itemTitleURL) {
    return element => avangaEncodeURI(element.title) === itemTitleURL;
  }

  componentDidMount() {
    const filters = document.querySelectorAll('section.movies .movie-filter ul li');

    for (const item of filters) {
      item.addEventListener('mouseenter', this.mouseOverHandler);
    }

    // Page is called with Video Link.
    if (window.location.pathname.includes('/video/')) {
      const itemTitleURL = window.location.pathname.replace('/video/', ''),
        item = this.state.movies.filter(this.filterMoviesTitleURL(decodeURI(itemTitleURL)));

      this.filterHandler(item['0'].category['0']);

      let timeoutBefore = 750;

      if (this.state.isMobile) {
        timeoutBefore = 1500;
      }

      // Scroll Restoration.
      setTimeout(() => {
        let movieOpen = document.querySelector('.movie-full .open-item').parentNode;

        if (this.state.isMobile) {
          movieOpen = document.querySelector('.movie-full .open-item').parentNode.parentNode;
        }

        const movieNavigation = document.querySelector('section.movies .movie-filter'),
          movieSection = document.querySelector('section.movies'),
          scrollToPosition = movieSection.offsetTop + parseInt(movieOpen.style.top, 10) + movieNavigation.clientHeight;

        if (history && 'scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
        }

        window.scrollTo(0, scrollToPosition);
      }, timeoutBefore);
    }

    window.addEventListener('resize', this.resizeHandler);
  }

  componentWillUnmount() {
    const filters = document.querySelectorAll('section.movies .movie-filter ul li');

    for (const item of filters) {
      item.removeEventListener('mouseenter', this.mouseOverHandler);
    }

    window.removeEventListener('resize', this.resizeHandler);
  }
}

export default Movies;


// WEBPACK FOOTER //
// ./src/sections/movies/movies.jsx